import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exchange",
  "use": "exchange-usage",
  "viewBox": "0 0 27.3 15.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.3 15.9\" id=\"exchange\"><path d=\"M13.9 6.9l.8.8 3.8-3.8L14.7 0l-.8.8 2.5 2.5H0v8.8h1.1V4.4h15.3z\" /><path d=\"M27.3 3.9h-1.1v7.6H10.9L13.4 9l-.8-.8-3.8 3.9 3.8 3.8.8-.8-2.5-2.5h16.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol